
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import validate from 'utils/validateForm'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {reduxForm} from 'redux-form'
import Icon from 'components/Icon'
import SlideContainer from 'components/SlideContainer'
import FormInput from 'components/FormInput'
import {updateUser, deleteUser} from 'redux/modules/users/actions'

const fieldsMap = {
  name: {
    label: 'Name',
    validation: {
      isRequired: 'Please provide your name'
    }
  },
  email: {
    label: 'Email',
    validation: {
      isRequired: 'Please provide your email address',
      isEmail: 'Incorrect email address'
    }
  }
}

export class UserEditView extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    fields: PropTypes.object,
    handleSubmit: PropTypes.func,
    invalid: PropTypes.bool,
    userId: PropTypes.string,
    updateUser: PropTypes.func,
    deleteUser: PropTypes.func
  }

  render() {
    const {closeModal} = this.props

    return (
      <SlideContainer key='editUser' type='from-right'>
        <div className='user-edit-view'>
          <div className='user-edit-view_title'>Edit User</div>
          <Icon
            className='user-edit-view_close-icon'
            name='cross'
            size='25px'
            onClick={closeModal}
          />
          {this.renderForm()}
          {this.renderDeleteSection()}
        </div>
      </SlideContainer>
    )
  }

  renderForm() {
    const {
      fields,
      handleSubmit,
      invalid,
      closeModal
    } = this.props

    return (
      <form className='user-edit-view_form' onSubmit={handleSubmit(this.onSubmit)}>
        {Object.keys(fieldsMap).map((name, index) => {
          const {label} = fieldsMap[name]
          return (
            <FormInput
              key={index}
              label={label}
              {...fields[name]} />
          )
        })}
        <div className='user-edit-view_form_buttons'>
          <button type='submit' className='user-edit-view_form_submit' disabled={invalid}>Save user</button>
          <button className='user-edit-view_form_cancel' onClick={closeModal}>Cancel</button>
        </div>
      </form>
    )
  }

  renderDeleteSection() {
    return (
      <div className='user-edit-view_delete'>
        <div className='user-edit-view_delete_title'>
          Delete user
        </div>
        <div className='user-edit-view_delete_text'>
          To delete this user, use the button below.
           Please note all data associated with the User will be deleted permanently.
        </div>
        <div className='user-edit-view_delete_action'>
          <button className='user-edit-view_delete_button is-red' onClick={this.onUserDelete}>
            Delete User
          </button>
        </div>
      </div>
    )
  }

  onSubmit = values => {
    const {updateUser, userId} = this.props
    updateUser({
      userId,
      ...values
    })
  }

  onUserDelete = () => {
    const {deleteUser, userId} = this.props
    deleteUser(userId)
  }
}

const mapStateToProps = state => ({
})

export default reduxForm(
  {
    form: 'editUser',
    fields: Object.keys(fieldsMap),
    validate: validate(fieldsMap)
  },
  mapStateToProps,
  {
    closeModal,
    updateUser,
    deleteUser
  }
)(UserEditView)



// WEBPACK FOOTER //
// ./client/modals/UserEditView/index.js